import { motion } from 'framer-motion';

const steps = [
  { emoji: "🎯", title: "Strategy", desc: "Our creative team defines the strongest angles and ad formats to produce for your brand." },
  { emoji: "😎", title: "Concepts", desc: "We pitch unique, performance-driven ideas built for your brand — never recycled templates. You pick your favorites." },
  { emoji: "✍️", title: "Scripts", desc: "We write every script word-for-word, 100% optimized for performance." },
  { emoji: "🎬", title: "Shooting", desc: "We handle the entire shoot in-house — professional lighting, multiple angles, clear direction." },
  { emoji: "💻", title: "Editing", desc: "Full edit delivered 2 to 10 days after shooting day, optimized for high-performing ads." },
  { emoji: "📩", title: "Delivery", desc: "You receive completely unique creatives, with unlimited revisions until you're 100% satisfied." },
  { emoji: "❤️", title: "Satisfaction", desc: "You get high-performing ads, we get a great case study. Everybody wins." },
];

export const Method = () => (
  <section className="section" id="method">
    <div className="container mx-auto max-w-5xl px-4">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 leading-tight"
      >
        The method to actually get <span className="italic text-primary">results</span> (and finally explode your performance 💥)
      </motion.h2>
      <p className="text-muted-foreground text-center text-lg mb-16 max-w-2xl mx-auto">
        Seven steps. Zero guesswork. This is how we turn your brand into ads that convert.
      </p>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical line */}
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary/30 md:-translate-x-1/2" />

        <div className="space-y-12 md:space-y-20">
          {steps.map((s, i) => {
            const isLeft = i % 2 === 0;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 80 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15, margin: '0px 0px -10% 0px' }}
                transition={{ duration: 0.7, ease: 'easeOut' }}
                className="relative md:grid md:grid-cols-2 md:gap-12 items-start"
              >
                {/* Dot on line */}
                <div className="absolute left-4 md:left-1/2 top-6 -translate-x-1/2 w-3 h-3 rounded-full bg-primary ring-4 ring-background" />

                {/* Left column */}
                <div className={`${isLeft ? 'md:pr-12 md:text-right' : 'md:col-start-2 md:pl-12'} pl-12 md:pl-0`}>
                  <div className={`flex items-center gap-3 mb-4 ${isLeft ? 'md:justify-end' : ''}`}>
                    <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground text-sm font-bold">
                      {i + 1}
                    </span>
                    <h3 className="text-2xl md:text-3xl font-bold text-primary flex items-center gap-2">
                      {s.title} <span>{s.emoji}</span>
                    </h3>
                  </div>
                  <div className="glass-card !bg-primary/10 border border-primary/20 !text-left">
                    <p className="text-base text-foreground/90 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);